(() => {
  const configElement = document.getElementById('hp-rtbhouse-config');
  if (!configElement || window.HpRtbHouse) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch { return; }
  if (config.tagId !== 'w8fQArlgIFf14ePiPr8o') return;
  const nativeFetch = window.fetch.bind(window);
  const scriptUrl = `https://tags.creativecdn.com/${config.tagId}.js`;
  let initialized = false;
  let consentRevision = 0;
  let cartRevision = 0;
  let cartTimer;
  let lastCart = null;
  let pageSent = false;
  let storeObserved = false;
  let lastSize = '';

  function allowed(revision = consentRevision) {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      const cmpAllowed = !document.getElementById('ucookie') || window.HpTrackingConsent?.allows() === true;
      return cmpAllowed && revision === consentRevision && privacy?.analyticsProcessingAllowed?.() === true && privacy?.marketingAllowed?.() === true;
    } catch { return false; }
  }

  function productId(value) {
    if (typeof value === 'number' && !Number.isSafeInteger(value)) return '';
    const text = String(value ?? '');
    return /^[1-9]\d*$/.test(text) ? text : '';
  }

  function offerIds(values) {
    return [...new Set(values.map(productId).filter(Boolean))];
  }

  function send(payload) {
    if (!initialized || !allowed()) return false;
    try {
      return window.rtbhEvents.push(payload, { eventType: 'uid', id: /^[a-f0-9]{64}$/.test(config.uid) ? config.uid : 'unknown' }) !== false;
    } catch { return false; }
  }

  async function syncCart() {
    if (config.pageType !== 'cart' || !allowed()) return;
    const revision = ++cartRevision;
    const consent = consentRevision;
    try {
      const response = await nativeFetch(config.cartUrl, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (!allowed(consent) || revision !== cartRevision || !Array.isArray(cart.items)) return;
      const ids = offerIds(cart.items.filter(item => item.quantity > 0).map(item => item.product_id));
      const signature = JSON.stringify(ids);
      if (!ids.length) { lastCart = signature; return; }
      if (signature !== lastCart && send({ eventType: 'basketstatus', offerIds: ids })) lastCart = signature;
    } catch {}
  }

  function scheduleCart() {
    if (!initialized || !allowed() || config.pageType !== 'cart') return;
    cartRevision += 1;
    window.clearTimeout(cartTimer);
    cartTimer = window.setTimeout(syncCart, 100);
  }

  function cartAction(input) {
    try {
      const url = new URL(typeof input === 'string' ? input : input.url || String(input), window.location.href);
      return url.origin === window.location.origin ? url.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?\/?$/)?.[1] : '';
    } catch { return ''; }
  }

  function addedItems(data, revision) {
    if (!allowed(revision) || !data || data.status || data.errors) return;
    const items = Array.isArray(data.items) ? data.items : [data];
    const ids = offerIds(items.filter(item => Number(item.quantity) > 0).map(item => item.product_id));
    ids.forEach(id => send({ eventType: 'basketadd', offerId: id }));
  }

  window.fetch = function(input, options) {
    const action = cartAction(input);
    const revision = allowed() && initialized ? consentRevision : -1;
    const result = nativeFetch(input, options);
    if (!action) return result;
    return result.then(response => {
      if (response.ok && allowed(revision)) {
        scheduleCart();
        if (action === 'add') {
          try { response.clone().json().then(data => addedItems(data, revision)).catch(() => {}); } catch {}
        }
      }
      return response;
    });
  };

  const xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url, ...args) {
    if (this.hpRtbListener) this.removeEventListener('load', this.hpRtbListener);
    const action = cartAction(url);
    const revision = allowed() && initialized ? consentRevision : -1;
    this.hpRtbListener = null;
    if (action) {
      this.hpRtbListener = () => {
        if (this.status < 200 || this.status >= 300 || !allowed(revision)) return;
        scheduleCart();
        if (action === 'add') {
          try { addedItems(this.responseType === 'json' ? this.response : JSON.parse(this.responseText), revision); } catch {}
        }
      };
      this.addEventListener('load', this.hpRtbListener, { once: true });
    }
    return xhrOpen.call(this, method, url, ...args);
  };

  function observeCartStore() {
    if (storeObserved || typeof window.cartSubscribe !== 'function') return;
    storeObserved = true;
    let changing = false;
    window.cartSubscribe(state => {
      if (!state) return;
      if (state.changeLineLoading !== -1) changing = true;
      else if (changing) {
        changing = false;
        if (!state.changeErrorMessage) scheduleCart();
      }
    });
  }

  function pageEvent() {
    if (pageSent) return;
    pageSent = true;
    if (config.pageType === 'index') send({ eventType: 'home' });
    else if (config.pageType === 'product' && productId(config.productId)) send({ eventType: 'offer', offerId: productId(config.productId) });
    else if (config.pageType === 'collection' && config.categoryName) send({ eventType: 'category', categoryName: config.categoryName });
    else if (config.pageType === 'search') send({ eventType: 'listing', offerIds: offerIds(config.searchOfferIds || []).slice(0, 5) });
    else if (config.pageType !== 'cart') send({ eventType: 'placebo' });
    scheduleCart();
  }

  function initialize() {
    if (!allowed()) {
      consentRevision += 1;
      cartRevision += 1;
      lastCart = null;
      lastSize = '';
      window.clearTimeout(cartTimer);
      if (Array.isArray(window.rtbhEvents) && window.rtbhEvents.push === Array.prototype.push) {
        window.rtbhEvents.length = 0;
        document.querySelector(`script[data-hp-rtb-loader][src="${scriptUrl}"]`)?.remove();
      }
      return;
    }
    if (!initialized) {
      initialized = true;
      window.rtbhEvents = window.rtbhEvents || [];
      window.rtbhEvents.push({ eventType: 'init', value: config.tagId, dc: '' });
    } else if (!window.rtbhEvents.length) {
      window.rtbhEvents.push({ eventType: 'init', value: config.tagId, dc: '' });
      pageSent = false;
    }
    pageEvent();
    scheduleCart();
    if (!document.querySelector(`script[src="${scriptUrl}"]`)) {
      const script = document.createElement('script');
      script.src = scriptUrl;
      script.async = true;
      script.setAttribute('data-hp-rtb-loader', '');
      script.onerror = () => script.remove();
      document.head.appendChild(script);
    }
  }

  document.addEventListener('change', event => {
    const input = event.target;
    if (!event.isTrusted || !input.matches?.('xo-product-variants input[type="radio"], xo-product-variants select, [data-hp-sticky-variant-clone] input[type="radio"]') || input.disabled || input.hasAttribute('xo-disabled') || input.hasAttribute('xo-unavailable')) return;
    const name = (input.name || '').replace(/^\{product_\d+\}/, '').replace(/__hp_sticky$/, '');
    if (!/^(beden|size)$/i.test(name) || !input.value || input.value === lastSize) return;
    if (send({ eventType: 'size', size: input.value })) lastSize = input.value;
  });
  document.addEventListener('click', event => {
    if (event.isTrusted && event.target.closest?.('.pdp-store-pickup-trigger')) send({ eventType: 'offlinecheck' });
  });
  document.addEventListener('cart:refresh', scheduleCart);
  document.addEventListener('DOMContentLoaded', observeCartStore, { once: true });
  document.addEventListener('visitorConsentCollected', initialize);
  document.addEventListener('hp:tracking-consent-changed', initialize);
  window.addEventListener('pageshow', event => {
    if (event.persisted) { pageSent = false; lastCart = null; config.uid = 'unknown'; initialize(); }
  });
  window.HpRtbHouse = {
    updateUid: value => { if (allowed() && (value === 'unknown' || /^[a-f0-9]{64}$/.test(value))) config.uid = value; },
    wishlistAdded: value => productId(value) ? send({ eventType: 'wishlist', offerId: productId(value) }) : false,
    searchResults: values => Array.isArray(values) ? send({ eventType: 'listing', offerIds: offerIds(values).slice(0, 5) }) : false,
  };
  observeCartStore();
  if (window.Shopify?.customerPrivacy) initialize();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) initialize(); });
})();
